import React from "react";
import {ThemeProvider, createTheme, makeStyles} from "@material-ui/core/styles";
import defaultLightPalette, {previsionPalette} from "../../services/defaultLightPalette";
import { Switch, Route, NavLink} from "react-router-dom";
import {useTranslation}     from 'react-i18next';
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";

import Investigation from "./Investigation.jsx";
import Investigations from "./Investigations.jsx";
import {useSelector} from "react-redux";
import {getCurrentUser} from "../../store/entities/currentUserSlice";

const InvestigationsRouter = () => {
    const {t, i18n} = useTranslation();
    const classes = useStyles();
    const currentUser = useSelector(getCurrentUser);

    // TODO improve breadbrumb
    return <Container maxWidth={"xl"} disableGutters={true}>
        <ThemeProvider theme={lightTheme(currentUser && currentUser.type === "prevision")}>
            <Switch>
                <Route exact path="/investigations" >
                    <Breadcrumbs separator="/">
                        <Link to="/" component={NavLink} className={classes.Link}>
                            {t('HomePageLink')}
                        </Link>
                        <Typography>
                            {t('InvestigationsLink')}
                        </Typography>
                    </Breadcrumbs>
                    <Investigations/>
                </Route>
                <Route path="/investigations/:investigationId">
                    <InvestigationsBreadCrumbs current={<Typography>Current</Typography>} />
                    <Investigation/>
                </Route>
            </Switch>
        </ThemeProvider>
    </Container>;
};

function InvestigationsBreadCrumbs({current}) {
    const {t, i18n} = useTranslation();
    const classes = useStyles();
    return <Breadcrumbs separator="/">
        <Link to="/" component={NavLink} className={classes.Link}>
            {t('HomePageLink')}
        </Link>
        <Link to="/investigations/" component={NavLink} className={classes.Link}>
            {t('InvestigationsLink')}
        </Link>
        {current && current}
    </Breadcrumbs>
}

// Theme
const lightTheme = (prevision = false) => createTheme({
    ...(!prevision ? defaultLightPalette : previsionPalette)
});

// style of the layout
const useStyles = makeStyles((theme) => ({
    Link: {
        color: 'white'
    }
}));

export default InvestigationsRouter;